import React from "react";
import { PageLoader } from "@vionixasia/shared-components";
import { Navigate } from "react-router-dom";
import { useAuth } from "@vionixasia/shared-components";

export const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <PageLoader />;
  }

  if (!user) {
    // For local development across different ports, redirect to local /login 
    // to ensure the Firebase session is established for this specific origin.
    return <Navigate to="/login" state={{ from: window.location.pathname }} replace />;
  }

  // Check if user is authenticated AND has role 'admin'
  if (user.role !== "admin") {
    // Optional: Redirect to a specific "Access Denied" page or just Home
    return <Navigate to="/" replace />;
  }

  return children;
};
